import {
  ProgressReportScopeType,
  VersionReportPageConfig,
  VersionReportPageType,
} from './index'

/**
 * ページ構成は config_json_string に不定形の JSON として保存されるため、
 * 読み書きの両方向をこのモジュールに閉じてキーの取り違えを防ぐ。
 * tableRows は rows テーブル側で管理するため JSON には含めない。
 */
export const buildConfigJsonString = (
  config: VersionReportPageConfig
): string => {
  switch (config.type) {
    case 'PROGRESS_OVERVIEW':
      return JSON.stringify({})
    case 'PROGRESS_REPORT_BY_PROCESS':
      return JSON.stringify({})
    case 'PROGRESS_REPORT_BY_TEAM':
      return JSON.stringify({
        scopeType: config.scopeType,
        rootUuid: config.rootUuid,
      })
  }
}

export const parsePageConfig = (
  pageType: VersionReportPageType,
  configJsonString: string | undefined,
  tableRows: string[]
): VersionReportPageConfig => {
  const stored = parseJsonObject(configJsonString)
  switch (pageType) {
    case 'PROGRESS_OVERVIEW':
      return { type: pageType, tableRows }
    case 'PROGRESS_REPORT_BY_PROCESS':
      return { type: pageType, tableRows }
    case 'PROGRESS_REPORT_BY_TEAM':
      return {
        type: pageType,
        scopeType: toScopeType(stored.scopeType),
        rootUuid: toUuid(stored.rootUuid),
        tableRows,
      }
  }
}

const parseJsonObject = (
  configJsonString: string | undefined
): Record<string, unknown> => {
  const parsed: unknown = JSON.parse(configJsonString || '{}')
  return typeof parsed === 'object' && parsed !== null ? { ...parsed } : {}
}

// scopeType 導入前に保存されたページは工程基準しか持たない
const toScopeType = (value: unknown): ProgressReportScopeType =>
  value === 'TICKET_LIST' ? 'TICKET_LIST' : 'PROCESS'

const toUuid = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : undefined
